import { IUpdatePhoneBookRequest } from '@gem/models/userModel';
import { clearPhoneNumber } from '@gem/utils';

import { addToContact } from 'APP/model/contact/contactModel';
import Entities from 'STORE';
import type { User } from 'STORE/Users/User/User';

import { INewContactFormData } from '../../NewContactView/NewContactView.types';

export const createContact = async (values: INewContactFormData): Promise<User | null> => {
  const { contactNameSearch, contactPhone } = values;
  const payload: IUpdatePhoneBookRequest = {
    added: [
      {
        contactName: contactNameSearch.trim(),
        contactPhone: clearPhoneNumber(contactPhone),
        inAppContact: true,
      },
    ],
    last: true,
  };

  try {
    const createdContacts = await addToContact(payload);

    if (createdContacts.length) {
      const createdContact = createdContacts[0];
      Entities.usersStore.add([createdContact]);
      Entities.usersStore.addContact(createdContact.id);
      return Entities.usersStore.getUserById(createdContact.id);
    }
  } catch {
    // do nothing
  }

  return null;
};
